import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }
const _hoisted_3 = { class: "header-container" }
const _hoisted_4 = { class: "members-container" }
const _hoisted_5 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_6 = { class: "name-container" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_8 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_9 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_10 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_11 = { style: { overflowX: 'auto' } }
const _hoisted_12 = { class: "window-header-container" }
const _hoisted_13 = { class: "rounded-xl pa-2 title-container--left" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_16 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_17 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_18 = {
  key: 4,
  class: "mt-2"
}

import { firestore as db, storage } from '@/main'
import { onMounted, ref, watch } from 'vue'
import { Member } from '@/types/Member'
import { query, collection, getDocs, doc, deleteDoc, orderBy } from 'firebase/firestore'
import { ref as storageRef, deleteObject } from 'firebase/storage'
import { useTheme } from 'vuetify/lib/composables/theme'
import { useRouter } from 'vue-router'
import { Delta, QuillEditor } from '@vueup/vue-quill'
import { useAuthStore } from '@/stores/AuthStateStore'
import { storeToRefs } from 'pinia'

import '@/styles/global.scss'
import '@vueup/vue-quill/dist/vue-quill.bubble.css'
import HeaderComponent from '@/components/home/HeaderComponent.vue'
import CommonProgress from '@/components/common/CommonProgress.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MembersView',
  setup(__props) {

const options = ref([
  'Professor', 'Researcher', 'Student', 'Alumni'
])

const selectedOption = ref('Professor')
const members = ref<Member[]>([])
const filteredMembers = ref<Member[]>([])
const membersQuery = query(collection(db, 'Members'), orderBy('name'))
const isLoading = ref(true)
const theme = useTheme()
const router = useRouter()
const searchText = ref('')
const alwaysExpandAll = ref(false)
const selectedMember = ref<Member | null>(null)
const showWindow = ref(false)
const { isSignedIn, isAdmin } = storeToRefs(useAuthStore())

function isExpandedAll () {
  return filteredMembers.value.every(member => member.showCareer)
}

function expandAll () {
  const expand = !isExpandedAll()
  alwaysExpandAll.value = !isExpandedAll()
  filteredMembers.value.forEach(member => {
    member.showCareer = expand
  })
}

function filterMembers () {
  filteredMembers.value = members.value.filter(member => member.cat === selectedOption.value)

  if (alwaysExpandAll.value) {
    filteredMembers.value.forEach(member => {
      member.showCareer = true
    })
  }
}

function deleteMember (member: Member) {
  if (confirm(`Are you sure you want to delete member ${member.name}?\nThis action cannot be undone.`)) {
    showWindow.value = false
    isLoading.value = true
    deleteDoc(doc(db, 'Members', member.id as string))
      .then(() => {
        if (member.profile !== '' && member.profile !== undefined && member.profile !== null) {
          deleteObject(storageRef(storage, `members/img/${member.id}.${member.profile.split('.').pop()?.split('?')[0]}`))
            .catch((e: Error) => {
              alert(`An error occurred while deleting profile image.\nPlease try again later.\n(${e.message})`)
            })
            .finally(() => {
              alert('Member deleted successfully.')
              members.value = members.value.filter(m => m.id !== member.id)
              filterMembers()
              isLoading.value = false
            })
        } else {
          alert('Member deleted successfully.')
          members.value = members.value.filter(m => m.id !== member.id)
          filterMembers()
          isLoading.value = false
        }
      })
      .catch((e: Error) => {
        alert(`An error occurred while deleting member.\nPlease try again later.\n(${e.message})`)
        isLoading.value = false
      })
  }
}

onMounted(() => {
  getDocs(membersQuery)
    .then((data) => {
      members.value = data.docs.map((doc) => ({
        ...(doc.data() as Member),
        id: doc.id,
        careerDelta: doc.data().career === '' || doc.data().career === undefined ? undefined : new Delta(JSON.parse(doc.data().career || '{}')),
        showCareer: false
      }))

      filterMembers()
    })
    .catch((e: Error) => {
      console.log(e.message)
    })
    .finally(() => {
      isLoading.value = false
    })
})

watch(selectedOption, () => {
  filterMembers()
})

watch(searchText, () => {
  if (searchText.value === '') {
    filterMembers()
  } else {
    filteredMembers.value = members.value.filter(member => member.name.toLowerCase().includes(searchText.value.toLowerCase()) || (member.dept !== undefined && member.dept.toLowerCase().includes(searchText.value.toLowerCase())) || (member.degree !== undefined && member.degree.toLowerCase().includes(searchText.value.toLowerCase())) || (member.interests !== undefined && member.interests.toLowerCase().includes(searchText.value.toLowerCase())) || (member.email !== undefined && member.email.toLowerCase().includes(searchText.value.toLowerCase())) || (member.tel !== undefined && member.tel.toLowerCase().includes(searchText.value.toLowerCase())))
  }
})

watch(showWindow, () => {
  if (!showWindow.value) {
    selectedMember.value = null
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(HeaderComponent, {
              title: 'Members',
              "show-secondary-trailing-btn": true,
              "secondary-trailing-icon": isExpandedAll() ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down',
              onOnSecondaryBtnClick: _cache[0] || (_cache[0] = ($event: any) => (expandAll())),
              onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/create-member')))
            }, null, 8, ["secondary-trailing-icon"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ml-2 chips-container",
                key: option
              }, [
                (selectedOption.value === option && searchText.value === '')
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      "prepend-icon": "mdi-check",
                      variant: "tonal",
                      color: "primary",
                      class: "rounded-pill"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createBlock(_component_v_chip, {
                      key: 1,
                      onClick: ($event: any) => (selectedOption.value = option),
                      variant: "tonal",
                      class: "rounded-pill",
                      disabled: searchText.value !== ''
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"]))
              ]))
            }), 128))
          ]),
          _createVNode(_component_v_text_field, {
            class: "mt-5 search-bar",
            modelValue: searchText.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchText).value = $event)),
            label: "Search Members",
            color: "primary",
            "prepend-inner-icon": "mdi-magnify",
            variant: "outlined",
            "clear-icon": "mdi-close",
            clearable: "",
            "onClick:clear": _cache[3] || (_cache[3] = ($event: any) => (searchText.value = ''))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            (isLoading.value)
              ? (_openBlock(), _createBlock(CommonProgress, { key: 0 }))
              : (!isLoading.value && filteredMembers.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" }),
                    _cache[10] || (_cache[10] = _createTextVNode(" " + _toDisplayString('No members found'), -1))
                  ]))
                : (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMembers.value, (member) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "4",
                          xl: "3",
                          xxl: "3",
                          class: "mt-5",
                          key: member.id
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_card, {
                                class: "rounded-xl",
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, {
                                    class: "text-h4 font-weight-medium mt-2",
                                    style: {"word-break":"break-word","white-space":"normal"}
                                  }, {
                                    default: _withCtx(() => [
                                      (searchText.value !== '')
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 0,
                                            class: "rounded-xl",
                                            color: "primary",
                                            variant: "tonal"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(member.cat), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      (member.profile !== '' && member.profile !== undefined && member.profile !== null)
                                        ? (_openBlock(), _createBlock(_component_v_img, {
                                            key: 1,
                                            src: member.profile,
                                            width: "200px",
                                            height: "200px"
                                          }, null, 8, ["src"]))
                                        : (_openBlock(), _createBlock(_component_v_img, {
                                            key: 2,
                                            src: member.cat === 'Alumni' ? require(`@/assets/img_placeholder_graduate_${_unref(theme).current.value.dark ? 'dark' : 'light'}.png`) : require(`@/assets/img_placeholder_employee_${_unref(theme).current.value.dark ? 'dark' : 'light'}.png`),
                                            width: "200px",
                                            height: "200px"
                                          }, null, 8, ["src"])),
                                      _createElementVNode("div", _hoisted_6, [
                                        _createVNode(_component_v_chip, {
                                          variant: "outlined",
                                          class: "rounded-xl",
                                          color: "primary"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(member.degree), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createTextVNode(" " + _toDisplayString(member.name), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      (member.email !== '')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-envelope" }),
                                            _createTextVNode(" " + _toDisplayString(member.email), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (member.tel !== '')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-phone" }),
                                            _createTextVNode(" " + _toDisplayString(member.tel), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (member.degree !== undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-graduation-cap" }),
                                            _createTextVNode(" " + _toDisplayString(member.dept), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (member.interests !== '' && member.interests !== undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-star" }),
                                            _createTextVNode(" " + _toDisplayString(member.interests), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (member.showCareer)
                                        ? (_openBlock(), _createBlock(_unref(QuillEditor), {
                                            key: 4,
                                            class: "mt-2",
                                            content: member.careerDelta,
                                            "onUpdate:content": ($event: any) => ((member.careerDelta) = $event),
                                            options: { readOnly: true, theme: 'bubble', modules: { toolbar: false } }
                                          }, null, 8, ["content", "onUpdate:content"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_actions, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_11, [
                                        (member.career !== '')
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              onClick: ($event: any) => (member.showCareer = !member.showCareer)
                                            }, {
                                              default: _withCtx(() => [
                                                (member.showCareer)
                                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                      key: 0,
                                                      icon: "fa-solid fa-chevron-up"
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                      key: 1,
                                                      icon: "fa-solid fa-chevron-down"
                                                    }))
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_btn, {
                                          variant: "text",
                                          onClick: ($event: any) => {{
                            selectedMember.value = member;
                            showWindow.value = true;
                          }}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-window-maximize" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        (member.website !== '')
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              color: _unref(theme).current.value.colors['on-background'],
                                              href: member.website
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-link" })
                                              ]),
                                              _: 2
                                            }, 1032, ["color", "href"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_btn, {
                                          variant: "text",
                                          onClick: ($event: any) => (_unref(router).push({ path: '/publications', query: { author: member.name } }))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-magnifying-glass" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        (_unref(isSignedIn) && _unref(isAdmin))
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 2,
                                              onClick: ($event: any) => (_unref(router).push({
                            name: 'modifyMember',
                            state: {
                              member: {
                                id: member.id,
                                email: member.email ?? '',
                                tel: member.tel ?? '',
                                website: member.website ?? '',
                                career: member.career ?? '',
                                careerDelta: JSON.stringify(member.careerDelta ?? ''),
                                cat: member.cat ?? '',
                                degree: member.degree ?? '',
                                dept: member.dept ?? '',
                                name: member.name ?? '',
                                interests: member.interests ?? ''
                              }
                            }
                          }))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-edit" })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (_unref(isSignedIn) && _unref(isAdmin))
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 3,
                                              color: "red",
                                              onClick: ($event: any) => (deleteMember(member))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
          ])
        ])
      ]),
      _: 1
    }),
    (showWindow.value && selectedMember.value !== null)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: showWindow.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showWindow).value = $event)),
          class: "dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-5 card" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "rounded-xl title-container" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_v_chip, {
                          variant: "outlined",
                          class: "rounded-xl mr-2",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedMember.value.degree), 1)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(selectedMember.value.name), 1)
                      ]),
                      _createVNode(_component_v_btn, {
                        class: "title-container--right",
                        color: "red",
                        variant: "tonal",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {selectedMember.value = null; showWindow.value = false;})
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (selectedMember.value.profile !== '' && selectedMember.value.profile !== undefined && selectedMember.value.profile !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_v_img, {
                            src: selectedMember.value.profile,
                            height: "40vh"
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_chip, {
                      variant: "tonal",
                      color: "primary",
                      class: "rounded-xl mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(selectedMember.value.cat), 1)
                      ]),
                      _: 1
                    }),
                    (selectedMember.value.email !== '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-envelope" }),
                          _createTextVNode(" " + _toDisplayString(selectedMember.value.email), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (selectedMember.value.tel !== '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-phone" }),
                          _createTextVNode(" " + _toDisplayString(selectedMember.value.tel), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (selectedMember.value.degree !== undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-graduation-cap" }),
                          _createTextVNode(" " + _toDisplayString(selectedMember.value.dept), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (selectedMember.value.interests !== '' && selectedMember.value.interests !== undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-star" }),
                          _createTextVNode(" " + _toDisplayString(selectedMember.value.interests), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(QuillEditor), {
                      class: "mt-2",
                      content: selectedMember.value.careerDelta,
                      "onUpdate:content": _cache[5] || (_cache[5] = ($event: any) => ((selectedMember.value.careerDelta) = $event)),
                      options: { readOnly: true, theme: 'bubble', modules: { toolbar: false } }
                    }, null, 8, ["content"]),
                    _createElementVNode("div", null, [
                      (selectedMember.value.website !== '')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "mt-2 mr-2 text-button",
                            variant: "tonal",
                            href: selectedMember.value.website
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "fa-solid fa-link",
                                class: "mr-2"
                              }),
                              _createTextVNode(" " + _toDisplayString(selectedMember.value.website), 1)
                            ]),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        variant: "tonal",
                        class: "mt-2 text-button",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push({ path: '/publications', query: { author: selectedMember.value.name } })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            class: "mr-2",
                            icon: "fa-solid fa-magnifying-glass"
                          }),
                          _cache[11] || (_cache[11] = _createTextVNode(" " + _toDisplayString('Find Publications'), -1))
                        ]),
                        _: 1,
                        __: [11]
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    (_unref(isSignedIn) && _unref(isAdmin))
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => {{
            showWindow.value = false;
            _unref(router).push({
                name: 'modifyMember',
                state: {
                  member: {
                    id: selectedMember.value.id,
                    email: selectedMember.value.email ?? '',
                    tel: selectedMember.value.tel ?? '',
                    website: selectedMember.value.website ?? '',
                    career: selectedMember.value.career ?? '',
                    careerDelta: JSON.stringify(selectedMember.value.careerDelta ?? ''),
                    cat: selectedMember.value.cat ?? '',
                    degree: selectedMember.value.degree ?? '',
                    dept: selectedMember.value.dept ?? '',
                    name: selectedMember.value.name ?? '',
                    interests: selectedMember.value.interests ?? ''
                  }
                }
              });
          }})
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-edit" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(isSignedIn) && _unref(isAdmin))
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          color: "red",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (deleteMember(selectedMember.value)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})